import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BackendService from '../services/BaseBackendService';

const Forward: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const lastHandledSearch = useRef<string | null>(null);

  useEffect(() => {
    if (lastHandledSearch.current === location.search) {
      console.log('Forward already handled for search:', location.search);
      return;
    }

    lastHandledSearch.current = location.search;

    const forward = async () => {
      console.info('[impersonation:web] Forward handler start', {
        search: location.search,
        href: window.location.href,
      });
      console.log('[Forward] Component useEffect triggered');
      console.log('[Forward] Full location:', {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        href: window.location.href,
      });

      const params = new URLSearchParams(location.search);
      const raw = params.get('forwardUrl');

      console.log('[Forward] URL params:', {
        raw,
        rawLength: raw?.length,
        allParams: Object.fromEntries(params.entries()),
        locationSearch: location.search,
        locationSearchLength: location.search.length,
      });

      // Special handling for /forward route - call setRolesCache directly
      console.log('Forward route: calling setRolesCache directly (first API call)');
      try {
        const backendService = new BackendService();
        await backendService.setRolesCache();
        console.log('Roles cache set successfully via Forward component');
      } catch (error) {
        console.error('Failed to set roles cache in Forward component:', error);
        // Continue with navigation even if roles cache fails
      }

      if (!raw) {
        console.warn('[Forward] No forwardUrl found in query params');
        console.log('[Forward] All query params:', Object.fromEntries(params.entries()));
        console.log('[Forward] Full URL:', window.location.href);
        console.log('[Forward] Navigating to home');
        navigate('/', { replace: true });
        return;
      }

      try {
        const url = decodeURIComponent(raw);
        console.log('[Forward] Successfully decoded URL:', {
          raw,
          decoded: url,
          urlLength: url.length,
        });
        console.log('[Forward] Navigating to:', url);
        navigate(url, { replace: true });
      } catch (err) {
        console.error('[Forward] Error decoding forwardUrl:', {
          raw,
          error: err,
          errorMessage: err instanceof Error ? err.message : String(err),
        });
        console.log('[Forward] Navigating to home as fallback');
        navigate('/', { replace: true });
      }
    };

    void forward();
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
};

export default Forward;
